import { useEffect, useState } from "react";

const useActivityLogsData = (filters = {}, page = 1, limit = 50) => {
  const [activityLogs, setActivityLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("limit", limit);

        if (filters?.search) {
          params.append("search", filters.search);
        }

        if (filters?.dates?.date?.[0]) {
          params.append("start_date", filters.dates.date[0]);
        }

        if (filters?.dates?.date?.[1]) {
          params.append("end_date", filters.dates.date[1]);
        }

        // Activity (Plan Name) filter
        const activityPlan = filters?.planname?.default?.label;
        if (activityPlan && activityPlan !== "All") {
          params.append("planname", activityPlan);
        }

        // Current Plan filter (NEW)
        const currentPlan = filters?.currentPlan?.default?.label;
        if (currentPlan && currentPlan !== "All") {
          params.append("currentPlan", currentPlan);
        }

        const appName =
          window.localStorage.getItem("activeApp") || "Wishlist Guru";

        const url = `${
          process.env.REACT_APP_API_URL
        }/api/activity-logs?${params.toString()}`;

        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          signal,
          headers: {
            "Content-Type": "application/json",
            "x-app-name": appName,
          },
        });

        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(errorText || "Failed to fetch activity logs");
        }

        const data = await res.json();

        setActivityLogs(data.results || []);
        setTotalPages(data.totalPages || 1);
        setTotalRecords(data.totalRecords ?? 0);
      } catch (err) {
        if (err.name === "AbortError") return;

        setError(err);
        console.error("Error loading activity logs:", err);

        if (
          err.message.toLowerCase().includes("jwt expired") ||
          err.message.toLowerCase().includes("jwt must be provided")
        ) {
          localStorage.clear();
          alert("Token expired. Please login again.");
          window.location.href = "/";
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => controller.abort();
  }, [filters, page, limit]);

  return { activityLogs, loading, totalPages, totalRecords, error };
};

export default useActivityLogsData;
